"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tokens = _interopRequireDefault(require("../tokens"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MuiChip = function MuiChip(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      borderRadius: _tokens["default"].radii.semiRounded,
      color: theme.palette.grey[500],
      verticalAlign: 'baseline'
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 18
    },

    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    },

    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }
  };
};

var _default = MuiChip;
exports["default"] = _default;